import React from 'react';
import { useAppTheme, type AppId, type UseAppThemeOptions } from './useAppTheme';

interface AppThemeBootProps extends UseAppThemeOptions {
  /** Which app this is — drives the localStorage keys + admin endpoint slot. */
  appId: AppId;
  children?: React.ReactNode;
}

/**
 * Drop this once at the root of an app's React tree to apply the
 * admin-controlled per-app theme default (with a per-user override
 * stored in localStorage). The component renders `children` and
 * adds zero markup of its own.
 *
 *   <AppThemeBoot appId="admin-console">
 *     <App />
 *   </AppThemeBoot>
 *
 * Pair with `noFlashAppThemeScript(appId)` inlined in <head> to
 * eliminate the brief un-themed flash on first paint.
 */
export function AppThemeBoot({ appId, apiBaseUrl, skipFetch, children }: AppThemeBootProps) {
  useAppTheme(appId, { apiBaseUrl, skipFetch });
  return <>{children}</>;
}
